import { z } from 'zod';

const moneyRegex = /^\d+(\.\d{1,2})?$/;

export const CreatePagoDtoSchema = z
  .object({
    idCliente: z.coerce.number().int(),
    idTipoPago: z.coerce.number().int(),
    valor: z.string().regex(moneyRegex, 'valor must be a valid money value (max 2 decimals)'),
    latitud: z.coerce.number().optional(),
    longitud: z.coerce.number().optional(),
    comentario: z.string().optional(),
    fechaCobro: z.string().optional(),
    nombreCliente: z.string().optional(),
    // Billing core (Fase B) — prepago (modalidad ADELANTADO). 'NORMAL' is the
    // historical behavior and the default, keeping the existing flow intact.
    modalidad: z.enum(['NORMAL', 'ADELANTADO']).default('NORMAL'),
    mesesAdelantado: z.coerce.number().int().min(1).max(12).optional(),
    descuentoTipo: z.enum(['MONTO', 'PORCENTAJE']).nullable().optional(),
    descuentoValor: z.coerce.number().min(0).optional(),
    totalPlanificado: z
      .string()
      .regex(moneyRegex, 'totalPlanificado must be a valid money value (max 2 decimals)')
      .optional(),
    // Boleta (deposito/transferencia) — Fase E2: candidatos OCR que el
    // operador confirma/corrige antes de crear el pago (human-in-the-loop).
    // archivoBoleta es el nombre del archivo devuelto por POST /pagos/boleta/ocr.
    referenciaBoleta: z.string().optional(),
    montoBoleta: z.string().optional(),
    fechaBoleta: z.string().optional(),
    archivoBoleta: z.string().optional(),
  })
  .superRefine((val, ctx) => {
    if (val.modalidad === 'ADELANTADO' && val.mesesAdelantado === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['mesesAdelantado'],
        message: 'mesesAdelantado (1-12) is required when modalidad is ADELANTADO',
      });
    }
    if (Number(val.valor) <= 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['valor'],
        message: 'valor must be greater than 0',
      });
    }
  });

export type CreatePagoDto = z.infer<typeof CreatePagoDtoSchema>;

export const AnularPagoDtoSchema = z.object({
  motivo: z.string().min(1),
});

export type AnularPagoDto = z.infer<typeof AnularPagoDtoSchema>;

export const QueryPagosDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  idCliente: z.coerce.number().int().optional(),
  fechaDesde: z.string().optional(),
  fechaHasta: z.string().optional(),
  idEstadoPago: z.coerce.number().int().optional(),
  idTipoPago: z.coerce.number().int().optional(),
});

export type QueryPagosDto = z.infer<typeof QueryPagosDtoSchema>;
